import React, { useState, useEffect } from 'react';
import { Menu, X, CreditCard, LogOut } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../utils/auth';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasBlockedCards, setHasBlockedCards] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const navItems = [
    { path: '/Main', label: 'Home' },
    { path: '/statements', label: 'Statements' },
    { path: '/cardManage', label: 'Customer Card' },
    { path: '/block-unblock', label: 'Block / Unblock' },
    { path: '/cardReplace', label: 'Card Replacement' },
    { path: '/taxcertificate', label: 'Tax Certificate' },
    { path: '/cashBack', label: 'Cash Back' }
  ];

  useEffect(() => {
    // Read value already fetched by Dashboard — no extra API call needed
    setHasBlockedCards(sessionStorage.getItem('hasBlockedCards') === 'true');
    setLoading(false);

    const handler = (e) => setHasBlockedCards(e.detail.hasBlockedCards);
    window.addEventListener('cardsUpdated', handler);
    return () => window.removeEventListener('cardsUpdated', handler);
  }, []);

  const filteredNavItems = navItems;

  return (
    <header className="bg-white/90 backdrop-blur-lg shadow-xl border-b border-slate-200/60 sticky top-0 z-50 dark:bg-gray-900/90 dark:border-gray-700/60 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo Section */}
          <Link
            to="/"
            className="flex items-center space-x-3 group min-w-fit -ml-4" // Added -ml-4 (pulls it left by 1rem)
            aria-label="Go to Dashboard"
          >
            <div className="group-hover:scale-105 transition-all duration-300">
              <img src="/images/CC.png" alt="MCB Logo" className="h-10 w-auto" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 whitespace-nowrap">Card Manager</h1>
          </Link>

          <nav className="hidden md:flex space-x-8 items-center flex-nowrap" role="navigation">
            {filteredNavItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-slate-700 dark:text-slate-300 whitespace-nowrap hover:text-green-700 font-medium transition-all duration-200 relative group ${location.pathname === item.path ? 'text-green-700' : ''
                  }`}
              >
                {item.label}
                {/* ... existing underline span ... */}
              </Link>
            ))}
            {/* Ensure your logout button also doesn't wrap */}
            <button onClick={logout} className="flex items-center space-x-2 whitespace-nowrap ...">
              <LogOut className="h-4 w-4" />
              <span>Logout</span>
            </button>
          </nav>


          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-slate-700 dark:text-slate-300 hover:text-green-700 dark:hover:text-green-400 hover:bg-slate-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-green-700 dark:focus:ring-green-400 transition-all duration-300"
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200/50 dark:border-gray-700/50 animate-in slide-in-from-top-2 duration-300">
            <nav className="flex flex-col space-y-3" role="navigation">
              {filteredNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-slate-700 dark:text-slate-300 hover:text-green-700 dark:hover:text-green-400 font-medium transition-colors py-2 px-3 rounded-lg ${location.pathname === item.path ? 'bg-green-50 dark:bg-green-900/50 text-green-700 dark:text-green-400' : ''
                    }`}
                  aria-current={location.pathname === item.path ? 'page' : undefined}
                >
                  {item.label}
                </Link>
              ))}
              <button
                onClick={() => { logout(); setIsMenuOpen(false); }}
                className="flex items-center space-x-2 text-slate-700 dark:text-slate-300 hover:text-red-600 dark:hover:text-red-400 font-medium transition-colors py-2 px-3 rounded-lg text-left"
                aria-label="Logout"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;